import React from 'react';
import { Space, Typography } from 'antd';
import { CHAT_UI_THEME_TOKENS, DEFAULT_CHAT_UI_THEME } from '../../theme/themeTokens.js';
import { WORKFLOW_STATUS_LABELS } from './chatTimelineDraftChooserShared.js';

const { Text } = Typography;
const h = React.createElement;
const SUPPRESSED_DEFAULT_FIELD_KEYS = new Set(['constraints', 'scope', 'parameters']);

function firstTruthy(...values) {
  return values.find(Boolean);
}

function conditionalValue(condition, whenTrue, whenFalse = null) {
  return condition ? whenTrue : whenFalse;
}

function filterSuppressedFieldKeys(fields = []) {
  return fields
    .map((field) => String(field?.field_key || field || '').trim())
    .filter((fieldKey) => fieldKey && !SUPPRESSED_DEFAULT_FIELD_KEYS.has(fieldKey));
}

export function WorkflowCheckpointPanel(props) {
  const { item, themeTokens } = { themeTokens: CHAT_UI_THEME_TOKENS[DEFAULT_CHAT_UI_THEME], ...props };
  const payload = Object.assign({}, Object.assign({}, item).payload);
  const checkpoint = Object.assign({}, payload.checkpoint);
  const workflowId = String(checkpoint.workflow_id ?? '').trim();
  const checkpoints = Array.isArray(checkpoint.checkpoints) ? checkpoint.checkpoints : [];
  if (![workflowId, checkpoints.length > 0].every(Boolean)) {
    return null;
  }
  const activeCheckpointId = String(checkpoint.active_checkpoint_id ?? '').trim();
  const coverageValue = Number(payload.total_coverage);
  const requiredCoverageValue = Number(payload.required_coverage);
  const coverage = conditionalValue(Number.isFinite(coverageValue), coverageValue, 0);
  const requiredCoverage = conditionalValue(Number.isFinite(requiredCoverageValue), requiredCoverageValue, 0);
  const eligible = payload.analysis_entry_eligible === true;
  const requiredMissing = filterSuppressedFieldKeys(Array.isArray(payload.required_missing) ? payload.required_missing : []);
  const activeNode = Object.assign({}, firstTruthy(
    checkpoints.find((node) => String(Object.assign({}, node).checkpoint_id ?? '').trim() === activeCheckpointId),
    checkpoints[0]
  ));
  const activeStatus = String(firstTruthy(activeNode.status, 'queued')).trim().toLowerCase();
  const activeTitle = String(firstTruthy(activeNode.title, '梳理模式')).trim();

  return h(
    'div',
    { className: 'flare-assistant-meta-row' },
    h(
      'div',
      {
        style: {
          maxWidth: '78%',
          padding: '2px 0 0',
          width: '100%',
        },
      },
      h(
        Space,
        { orientation: 'vertical', size: 4, style: { width: '100%' } },
        h(
          'div',
          {
            className: 'flare-workflow-panel-head',
            style: {
              alignItems: 'center',
              columnGap: 8,
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              rowGap: 2,
            },
          },
          h(Text, { strong: true, style: { color: themeTokens.textSecondary, fontSize: 12 } }, 'Workflow'),
          h(Text, { type: 'secondary', style: { fontSize: 12 } }, `${activeTitle} · ${firstTruthy(WORKFLOW_STATUS_LABELS[activeStatus], activeStatus)}`)
        ),
        h(
          'div',
          {
            className: 'flare-workflow-metrics',
            style: {
              color: themeTokens.textSecondary,
              columnGap: 12,
              display: 'flex',
              flexWrap: 'wrap',
              fontSize: 12,
              rowGap: 2,
            },
          },
          h('span', null, `总覆盖率 ${(coverage * 100).toFixed(0)}%`),
          h('span', null, `关键覆盖率 ${(requiredCoverage * 100).toFixed(0)}%`),
          h('span', { className: conditionalValue(eligible, 'is-eligible', '') }, conditionalValue(eligible, '可开始分析', '继续梳理中'))
        ),
        conditionalValue([requiredMissing.length > 0, Object.assign({}, payload.blocking).reason].some(Boolean), h(
          Text,
          { type: 'secondary', style: { fontSize: 12, color: themeTokens.textSecondary } },
          `阻塞信息：${firstTruthy(String(Object.assign({}, payload.blocking).reason ?? ''), `缺少字段 ${requiredMissing.join('、')}`)}`
        ))
      )
    )
  );
}
